webpackJsonp([19,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _userServices = __webpack_require__(25);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shared = __webpack_require__(8);
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(2);
	var log = __webpack_require__(4)();
	var LoginManager = __webpack_require__(146);
	var StorageController = __webpack_require__(21);
	var FormValidator = __webpack_require__(33);
	var Constants = __webpack_require__(55);
	
	__webpack_require__(606);
	
	$(function () {
	  Shared.init();
	  RegisterPage.init();
	});
	
	var RegisterPage = {};
	
	(function (RegisterPage) {
	
	  var registerFormValidator = null;
	
	  RegisterPage.init = function () {
	    setUpRegisterForm();
	    setUpEventListeners();
	
	    clearAllFieldErrors();
	
	    showRegisterPart();
	  };
	
	  function setUpEventListeners() {
	    var $confirmRegisterBtn = $(".confirm-registration-btn");
	    $confirmRegisterBtn.prop("disabled", true);
	
	    var $cancelRegisterBtn = $("#cancel-registration-btn");
	    $cancelRegisterBtn.on("click", function () {
	      utils.redirect("/login");
	    });
	
	    var $eulaCheckbox = $("#register-eula-checkbox");
	    $eulaCheckbox.prop("checked", false);
	
	    $eulaCheckbox.on("change", function (e) {
	      $confirmRegisterBtn.prop("disabled", !this.checked);
	    });
	
	    $confirmRegisterBtn.on("click", function (e) {
	      register();
	    });
	
	    $("#gameboardcode-info-btn").on("click", function () {
	      $("#boardcode-info-modal").modal("show");
	    });
	
	    Shared.setupGameboardCodeInput("#register-gameboard_code-input");
	  }
	
	  function clearAllFieldErrors() {
	    $(".form-control").removeClass("is-invalid");
	    $(".input-field-error").text("");
	  }
	
	  function setUpRegisterForm() {
	    registerFormValidator = new FormValidator({
	      selector: "#register-form",
	      validateOnChange: true,
	      rules: {
	        firstname: { required: true },
	        lastname: { required: true },
	        email: {
	          required: true,
	          overwriteValidator: function overwriteValidator(value) {
	            var isValid = utils.isValidEmail(value);
	            if (!isValid) {
	              $("#register-email-input-error").text(LanguageManager.getValueForKey(Constants.USER_EMAIL_INVALID));
	            } else {
	              $("#register-email-input-error").text("");
	            }
	
	            return isValid;
	          }
	        },
	        gameboardCode: {
	          required: true,
	          minLength: 14,
	          maxLength: 14
	        },
	        password: {
	          required: true,
	          // minLength: 6,
	          maxLength: 32
	        },
	        passwordRepeat: {
	          required: true,
	          // minLength: 6,
	          maxLength: 32,
	          sameAs: "password",
	          overwriteValidator: function overwriteValidator(value) {
	            var psw = $("#register-password-input").val();
	            var isValid = psw === value;
	
	            if (!isValid) {
	              var message = LanguageManager.getValueForKey("register.form.passwords_dont_match");
	              $("#register-password-input-error").text(message);
	              $("#register-password-repeat-input-error").text(message);
	            } else {
	              $("#register-password-input-error").text("");
	              $("#register-password-repeat-input-error").text("");
	            }
	
	            return isValid;
	          }
	        }
	      }
	    });
	  }
	
	  function register() {
	    clearAllFieldErrors();
	
	    //TODO: move to own function
	    var isValid = registerFormValidator.validate();
	
	    if (isValid) {
	      var formData = registerFormValidator.getFormData();
	
	      var user = {
	        firstname: formData.firstname,
	        lastname: formData.lastname,
	        username: formData.email,
	        gameboardCode: formData.gameboardCode,
	        email: formData.email,
	        password: formData.password
	      };
	
	      var $btn = $(".confirm-registration-btn");
	      $btn.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");
	
	      _userServices2.default.registerUser(user).then(function (data) {
	        showValidationPart(formData.email);
	      }).catch(function (appError) {
	        var message = LanguageManager.getValueForKey(appError.code);
	        switch (appError.code) {
	          case Constants.USER_EMAIL_INVALID:
	          case Constants.USER_DUPLICATE_EMAIL:
	          case Constants.USER_NOT_FOUND:
	          case Constants.USER_NOT_AUTHENTICATED:
	            $("#register-email-input-error").text(message);
	            $("#register-email-input").addClass("is-invalid");
	            return;
	
	          case Constants.PASSWORD_FORMAT_INVALID:
	            $("#register-password-input-error").text(message);
	            $("#register-password-input").addClass("is-invalid");
	            return;
	
	          case Constants.GAMEBOARD_NOT_FOUND:
	          case Constants.GAMEBOARD_MAX_USERS_REACHED:
	            $("#register-gameboard_code-input-error").text(message);
	            $("#register-gameboard_code-input").addClass("is-invalid");
	            return;
	        }
	
	        showGlobalError(appError.code);
	      }).finally(function () {
	        $btn.prop("disabled", false).removeClass("btn-loading");
	      });
	    }
	  }
	
	  function showRegisterPart() {
	    $("#part-register").show();
	    $("#part-validate").hide();
	  }
	
	  function showValidationPart(email) {
	    var message = LanguageManager.getValueForKey("register.validation.text");
	    var formattedMessage = utils.format(message, [email]);
	    $("#validation-text").html(formattedMessage);
	
	    $("#part-register").hide();
	    $("#part-validate").show();
	  }
	
	  function showGlobalError(errorCode) {
	    console.log(errorCode);
	    var errorPopup = $(".error-popup");
	    errorPopup.removeClass("show");
	    //trigger reflow
	    errorPopup.width();
	    errorPopup.addClass("show");
	    $(".error-popup .error-message").attr("data-localize", errorCode);
	    LanguageManager.applyLocale($(".error-popup .error-message"));
	  }
	})(RegisterPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 11
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 10;


/***/ }),

/***/ 606:
107

});


// WEBPACK FOOTER //
// js/register.af73545ec62df7ee4778.js